import { default as cancel_45contract0n8UkZ2k7EMeta } from "/home/forge/app.inaia.uk/pages/cancel-contract.vue?macro=true";
import { default as index1i2onrKXdYMeta } from "/home/forge/app.inaia.uk/pages/cash-balance/index.vue?macro=true";
import { default as indexKGrazYlR2GMeta } from "/home/forge/app.inaia.uk/pages/cash-balance/top-up/index.vue?macro=true";
import { default as indexgzwhzGrtsVMeta } from "/home/forge/app.inaia.uk/pages/cash-balance/withdraw/index.vue?macro=true";
import { default as dashboardRTJW1S1OnmMeta } from "/home/forge/app.inaia.uk/pages/dashboard.vue?macro=true";
import { default as _91type_93xGOLsC4EQUMeta } from "/home/forge/app.inaia.uk/pages/depot/[type].vue?macro=true";
import { default as _91id_93af5QJuNfYWMeta } from "/home/forge/app.inaia.uk/pages/depot/addsavingplan/[id].vue?macro=true";
import { default as _91id_930nu3AnfBR6Meta } from "/home/forge/app.inaia.uk/pages/depot/detail/[id].vue?macro=true";
import { default as _91type_93PvmvYYYDsKMeta } from "/home/forge/app.inaia.uk/pages/depot/new/[type].vue?macro=true";
import { default as indexldVuzk9a7dMeta } from "/home/forge/app.inaia.uk/pages/etf-transaction-history/index.vue?macro=true";
import { default as index6rlZmVXVfZMeta } from "/home/forge/app.inaia.uk/pages/inbox-message/index.vue?macro=true";
import { default as index3pXrB6Z18SMeta } from "/home/forge/app.inaia.uk/pages/index.vue?macro=true";
import { default as _91_91isin_93_93bzpnwUsQ4YMeta } from "/home/forge/app.inaia.uk/pages/instruments/buy/[[isin]].vue?macro=true";
import { default as _91isin_93vN6WXwU7zeMeta } from "/home/forge/app.inaia.uk/pages/instruments/details/[isin].vue?macro=true";
import { default as index_old0A1MClJpAtMeta } from "/home/forge/app.inaia.uk/pages/instruments/index_old.vue?macro=true";
import { default as indexbAa1NUTpAmMeta } from "/home/forge/app.inaia.uk/pages/instruments/index.vue?macro=true";
import { default as indexDYEZ1agkfOMeta } from "/home/forge/app.inaia.uk/pages/instruments/list/index.vue?macro=true";
import { default as _91_91isin_93_936BwvTLbxcXMeta } from "/home/forge/app.inaia.uk/pages/instruments/savings-plan/add/[[isin]].vue?macro=true";
import { default as _91_91isin_93_93wwQnJ5fNkfMeta } from "/home/forge/app.inaia.uk/pages/instruments/sell/[[isin]].vue?macro=true";
import { default as indexH1BPmoh3L1Meta } from "/home/forge/app.inaia.uk/pages/instruments/tax-exemption/index.vue?macro=true";
import { default as loginoojCoP1BXdMeta } from "/home/forge/app.inaia.uk/pages/login.vue?macro=true";
import { default as indexMySkabLD7yMeta } from "/home/forge/app.inaia.uk/pages/profile/index.vue?macro=true";
import { default as verifyk9WC9puIGkMeta } from "/home/forge/app.inaia.uk/pages/profile/verify.vue?macro=true";
import { default as registerb4XSeQjzDZMeta } from "/home/forge/app.inaia.uk/pages/register.vue?macro=true";
import { default as request_45passwordlENL1CYpeqMeta } from "/home/forge/app.inaia.uk/pages/request-password.vue?macro=true";
import { default as reset_45passwordEUzwTxxs6KMeta } from "/home/forge/app.inaia.uk/pages/reset-password.vue?macro=true";
import { default as reset_45pinMQcfdqgqlEMeta } from "/home/forge/app.inaia.uk/pages/reset-pin.vue?macro=true";
import { default as indexOJYtmcPvW4Meta } from "/home/forge/app.inaia.uk/pages/security-legal-document/index.vue?macro=true";
import { default as simulatorSNZaD0XieHMeta } from "/home/forge/app.inaia.uk/pages/simulator.vue?macro=true";
import { default as indexoi7YKemXLiMeta } from "/home/forge/app.inaia.uk/pages/support-tickets/index.vue?macro=true";
import { default as _91_91depotid_93_93FVu8kimYmWMeta } from "/home/forge/app.inaia.uk/pages/trading/buy/[[depotid]].vue?macro=true";
import { default as _91_91depotid_93_939ECQOIddwkMeta } from "/home/forge/app.inaia.uk/pages/trading/delivery/[[depotid]].vue?macro=true";
import { default as _91_91depotid_93_93QtA5akYQBXMeta } from "/home/forge/app.inaia.uk/pages/trading/sell/[[depotid]].vue?macro=true";
import { default as _91_91depotid_93_937EWRborpobMeta } from "/home/forge/app.inaia.uk/pages/trading/transfer/[[depotid]].vue?macro=true";
import { default as indexX3C3MZr5BkMeta } from "/home/forge/app.inaia.uk/pages/upvest-account-history/index.vue?macro=true";
import { default as indexvRlJgmSR2fMeta } from "/home/forge/app.inaia.uk/pages/upvest-activate/index.vue?macro=true";
export default [
  {
    name: cancel_45contract0n8UkZ2k7EMeta?.name ?? "cancel-contract___de",
    path: cancel_45contract0n8UkZ2k7EMeta?.path ?? "/de/cancel-contract",
    meta: cancel_45contract0n8UkZ2k7EMeta || {},
    alias: cancel_45contract0n8UkZ2k7EMeta?.alias || [],
    redirect: cancel_45contract0n8UkZ2k7EMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cancel-contract.vue").then(m => m.default || m)
  },
  {
    name: cancel_45contract0n8UkZ2k7EMeta?.name ?? "cancel-contract___en",
    path: cancel_45contract0n8UkZ2k7EMeta?.path ?? "/en/cancel-contract",
    meta: cancel_45contract0n8UkZ2k7EMeta || {},
    alias: cancel_45contract0n8UkZ2k7EMeta?.alias || [],
    redirect: cancel_45contract0n8UkZ2k7EMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cancel-contract.vue").then(m => m.default || m)
  },
  {
    name: cancel_45contract0n8UkZ2k7EMeta?.name ?? "cancel-contract___fr",
    path: cancel_45contract0n8UkZ2k7EMeta?.path ?? "/fr/cancel-contract",
    meta: cancel_45contract0n8UkZ2k7EMeta || {},
    alias: cancel_45contract0n8UkZ2k7EMeta?.alias || [],
    redirect: cancel_45contract0n8UkZ2k7EMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cancel-contract.vue").then(m => m.default || m)
  },
  {
    name: cancel_45contract0n8UkZ2k7EMeta?.name ?? "cancel-contract___nl",
    path: cancel_45contract0n8UkZ2k7EMeta?.path ?? "/nl/cancel-contract",
    meta: cancel_45contract0n8UkZ2k7EMeta || {},
    alias: cancel_45contract0n8UkZ2k7EMeta?.alias || [],
    redirect: cancel_45contract0n8UkZ2k7EMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cancel-contract.vue").then(m => m.default || m)
  },
  {
    name: index1i2onrKXdYMeta?.name ?? "cash-balance___de",
    path: index1i2onrKXdYMeta?.path ?? "/de/cash-balance",
    meta: index1i2onrKXdYMeta || {},
    alias: index1i2onrKXdYMeta?.alias || [],
    redirect: index1i2onrKXdYMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: index1i2onrKXdYMeta?.name ?? "cash-balance___en",
    path: index1i2onrKXdYMeta?.path ?? "/en/cash-balance",
    meta: index1i2onrKXdYMeta || {},
    alias: index1i2onrKXdYMeta?.alias || [],
    redirect: index1i2onrKXdYMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: index1i2onrKXdYMeta?.name ?? "cash-balance___fr",
    path: index1i2onrKXdYMeta?.path ?? "/fr/cash-balance",
    meta: index1i2onrKXdYMeta || {},
    alias: index1i2onrKXdYMeta?.alias || [],
    redirect: index1i2onrKXdYMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: index1i2onrKXdYMeta?.name ?? "cash-balance___nl",
    path: index1i2onrKXdYMeta?.path ?? "/nl/cash-balance",
    meta: index1i2onrKXdYMeta || {},
    alias: index1i2onrKXdYMeta?.alias || [],
    redirect: index1i2onrKXdYMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/index.vue").then(m => m.default || m)
  },
  {
    name: indexKGrazYlR2GMeta?.name ?? "cash-balance-top-up___de",
    path: indexKGrazYlR2GMeta?.path ?? "/de/cash-balance/top-up",
    meta: indexKGrazYlR2GMeta || {},
    alias: indexKGrazYlR2GMeta?.alias || [],
    redirect: indexKGrazYlR2GMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: indexKGrazYlR2GMeta?.name ?? "cash-balance-top-up___en",
    path: indexKGrazYlR2GMeta?.path ?? "/en/cash-balance/top-up",
    meta: indexKGrazYlR2GMeta || {},
    alias: indexKGrazYlR2GMeta?.alias || [],
    redirect: indexKGrazYlR2GMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: indexKGrazYlR2GMeta?.name ?? "cash-balance-top-up___fr",
    path: indexKGrazYlR2GMeta?.path ?? "/fr/cash-balance/top-up",
    meta: indexKGrazYlR2GMeta || {},
    alias: indexKGrazYlR2GMeta?.alias || [],
    redirect: indexKGrazYlR2GMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: indexKGrazYlR2GMeta?.name ?? "cash-balance-top-up___nl",
    path: indexKGrazYlR2GMeta?.path ?? "/nl/cash-balance/top-up",
    meta: indexKGrazYlR2GMeta || {},
    alias: indexKGrazYlR2GMeta?.alias || [],
    redirect: indexKGrazYlR2GMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/top-up/index.vue").then(m => m.default || m)
  },
  {
    name: indexgzwhzGrtsVMeta?.name ?? "cash-balance-withdraw___de",
    path: indexgzwhzGrtsVMeta?.path ?? "/de/cash-balance/withdraw",
    meta: indexgzwhzGrtsVMeta || {},
    alias: indexgzwhzGrtsVMeta?.alias || [],
    redirect: indexgzwhzGrtsVMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: indexgzwhzGrtsVMeta?.name ?? "cash-balance-withdraw___en",
    path: indexgzwhzGrtsVMeta?.path ?? "/en/cash-balance/withdraw",
    meta: indexgzwhzGrtsVMeta || {},
    alias: indexgzwhzGrtsVMeta?.alias || [],
    redirect: indexgzwhzGrtsVMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: indexgzwhzGrtsVMeta?.name ?? "cash-balance-withdraw___fr",
    path: indexgzwhzGrtsVMeta?.path ?? "/fr/cash-balance/withdraw",
    meta: indexgzwhzGrtsVMeta || {},
    alias: indexgzwhzGrtsVMeta?.alias || [],
    redirect: indexgzwhzGrtsVMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: indexgzwhzGrtsVMeta?.name ?? "cash-balance-withdraw___nl",
    path: indexgzwhzGrtsVMeta?.path ?? "/nl/cash-balance/withdraw",
    meta: indexgzwhzGrtsVMeta || {},
    alias: indexgzwhzGrtsVMeta?.alias || [],
    redirect: indexgzwhzGrtsVMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/cash-balance/withdraw/index.vue").then(m => m.default || m)
  },
  {
    name: dashboardRTJW1S1OnmMeta?.name ?? "dashboard___de",
    path: dashboardRTJW1S1OnmMeta?.path ?? "/de/dashboard",
    meta: dashboardRTJW1S1OnmMeta || {},
    alias: dashboardRTJW1S1OnmMeta?.alias || [],
    redirect: dashboardRTJW1S1OnmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: dashboardRTJW1S1OnmMeta?.name ?? "dashboard___en",
    path: dashboardRTJW1S1OnmMeta?.path ?? "/en/dashboard",
    meta: dashboardRTJW1S1OnmMeta || {},
    alias: dashboardRTJW1S1OnmMeta?.alias || [],
    redirect: dashboardRTJW1S1OnmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: dashboardRTJW1S1OnmMeta?.name ?? "dashboard___fr",
    path: dashboardRTJW1S1OnmMeta?.path ?? "/fr/dashboard",
    meta: dashboardRTJW1S1OnmMeta || {},
    alias: dashboardRTJW1S1OnmMeta?.alias || [],
    redirect: dashboardRTJW1S1OnmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: dashboardRTJW1S1OnmMeta?.name ?? "dashboard___nl",
    path: dashboardRTJW1S1OnmMeta?.path ?? "/nl/dashboard",
    meta: dashboardRTJW1S1OnmMeta || {},
    alias: dashboardRTJW1S1OnmMeta?.alias || [],
    redirect: dashboardRTJW1S1OnmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/dashboard.vue").then(m => m.default || m)
  },
  {
    name: _91type_93xGOLsC4EQUMeta?.name ?? "depot-type___de",
    path: _91type_93xGOLsC4EQUMeta?.path ?? "/de/depot/:type()",
    meta: _91type_93xGOLsC4EQUMeta || {},
    alias: _91type_93xGOLsC4EQUMeta?.alias || [],
    redirect: _91type_93xGOLsC4EQUMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93xGOLsC4EQUMeta?.name ?? "depot-type___en",
    path: _91type_93xGOLsC4EQUMeta?.path ?? "/en/depot/:type()",
    meta: _91type_93xGOLsC4EQUMeta || {},
    alias: _91type_93xGOLsC4EQUMeta?.alias || [],
    redirect: _91type_93xGOLsC4EQUMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93xGOLsC4EQUMeta?.name ?? "depot-type___fr",
    path: _91type_93xGOLsC4EQUMeta?.path ?? "/fr/depot/:type()",
    meta: _91type_93xGOLsC4EQUMeta || {},
    alias: _91type_93xGOLsC4EQUMeta?.alias || [],
    redirect: _91type_93xGOLsC4EQUMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93xGOLsC4EQUMeta?.name ?? "depot-type___nl",
    path: _91type_93xGOLsC4EQUMeta?.path ?? "/nl/depot/:type()",
    meta: _91type_93xGOLsC4EQUMeta || {},
    alias: _91type_93xGOLsC4EQUMeta?.alias || [],
    redirect: _91type_93xGOLsC4EQUMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/[type].vue").then(m => m.default || m)
  },
  {
    name: _91id_93af5QJuNfYWMeta?.name ?? "depot-addsavingplan-id___de",
    path: _91id_93af5QJuNfYWMeta?.path ?? "/de/depot/addsavingplan/:id()",
    meta: _91id_93af5QJuNfYWMeta || {},
    alias: _91id_93af5QJuNfYWMeta?.alias || [],
    redirect: _91id_93af5QJuNfYWMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93af5QJuNfYWMeta?.name ?? "depot-addsavingplan-id___en",
    path: _91id_93af5QJuNfYWMeta?.path ?? "/en/depot/addsavingplan/:id()",
    meta: _91id_93af5QJuNfYWMeta || {},
    alias: _91id_93af5QJuNfYWMeta?.alias || [],
    redirect: _91id_93af5QJuNfYWMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93af5QJuNfYWMeta?.name ?? "depot-addsavingplan-id___fr",
    path: _91id_93af5QJuNfYWMeta?.path ?? "/fr/depot/addsavingplan/:id()",
    meta: _91id_93af5QJuNfYWMeta || {},
    alias: _91id_93af5QJuNfYWMeta?.alias || [],
    redirect: _91id_93af5QJuNfYWMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_93af5QJuNfYWMeta?.name ?? "depot-addsavingplan-id___nl",
    path: _91id_93af5QJuNfYWMeta?.path ?? "/nl/depot/addsavingplan/:id()",
    meta: _91id_93af5QJuNfYWMeta || {},
    alias: _91id_93af5QJuNfYWMeta?.alias || [],
    redirect: _91id_93af5QJuNfYWMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/addsavingplan/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_930nu3AnfBR6Meta?.name ?? "depot-detail-id___de",
    path: _91id_930nu3AnfBR6Meta?.path ?? "/de/depot/detail/:id()",
    meta: _91id_930nu3AnfBR6Meta || {},
    alias: _91id_930nu3AnfBR6Meta?.alias || [],
    redirect: _91id_930nu3AnfBR6Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_930nu3AnfBR6Meta?.name ?? "depot-detail-id___en",
    path: _91id_930nu3AnfBR6Meta?.path ?? "/en/depot/detail/:id()",
    meta: _91id_930nu3AnfBR6Meta || {},
    alias: _91id_930nu3AnfBR6Meta?.alias || [],
    redirect: _91id_930nu3AnfBR6Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_930nu3AnfBR6Meta?.name ?? "depot-detail-id___fr",
    path: _91id_930nu3AnfBR6Meta?.path ?? "/fr/depot/detail/:id()",
    meta: _91id_930nu3AnfBR6Meta || {},
    alias: _91id_930nu3AnfBR6Meta?.alias || [],
    redirect: _91id_930nu3AnfBR6Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91id_930nu3AnfBR6Meta?.name ?? "depot-detail-id___nl",
    path: _91id_930nu3AnfBR6Meta?.path ?? "/nl/depot/detail/:id()",
    meta: _91id_930nu3AnfBR6Meta || {},
    alias: _91id_930nu3AnfBR6Meta?.alias || [],
    redirect: _91id_930nu3AnfBR6Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/detail/[id].vue").then(m => m.default || m)
  },
  {
    name: _91type_93PvmvYYYDsKMeta?.name ?? "depot-new-type___de",
    path: _91type_93PvmvYYYDsKMeta?.path ?? "/de/depot/new/:type()",
    meta: _91type_93PvmvYYYDsKMeta || {},
    alias: _91type_93PvmvYYYDsKMeta?.alias || [],
    redirect: _91type_93PvmvYYYDsKMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93PvmvYYYDsKMeta?.name ?? "depot-new-type___en",
    path: _91type_93PvmvYYYDsKMeta?.path ?? "/en/depot/new/:type()",
    meta: _91type_93PvmvYYYDsKMeta || {},
    alias: _91type_93PvmvYYYDsKMeta?.alias || [],
    redirect: _91type_93PvmvYYYDsKMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93PvmvYYYDsKMeta?.name ?? "depot-new-type___fr",
    path: _91type_93PvmvYYYDsKMeta?.path ?? "/fr/depot/new/:type()",
    meta: _91type_93PvmvYYYDsKMeta || {},
    alias: _91type_93PvmvYYYDsKMeta?.alias || [],
    redirect: _91type_93PvmvYYYDsKMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: _91type_93PvmvYYYDsKMeta?.name ?? "depot-new-type___nl",
    path: _91type_93PvmvYYYDsKMeta?.path ?? "/nl/depot/new/:type()",
    meta: _91type_93PvmvYYYDsKMeta || {},
    alias: _91type_93PvmvYYYDsKMeta?.alias || [],
    redirect: _91type_93PvmvYYYDsKMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/depot/new/[type].vue").then(m => m.default || m)
  },
  {
    name: indexldVuzk9a7dMeta?.name ?? "etf-transaction-history___de",
    path: indexldVuzk9a7dMeta?.path ?? "/de/etf-transaction-history",
    meta: indexldVuzk9a7dMeta || {},
    alias: indexldVuzk9a7dMeta?.alias || [],
    redirect: indexldVuzk9a7dMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexldVuzk9a7dMeta?.name ?? "etf-transaction-history___en",
    path: indexldVuzk9a7dMeta?.path ?? "/en/etf-transaction-history",
    meta: indexldVuzk9a7dMeta || {},
    alias: indexldVuzk9a7dMeta?.alias || [],
    redirect: indexldVuzk9a7dMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexldVuzk9a7dMeta?.name ?? "etf-transaction-history___fr",
    path: indexldVuzk9a7dMeta?.path ?? "/fr/etf-transaction-history",
    meta: indexldVuzk9a7dMeta || {},
    alias: indexldVuzk9a7dMeta?.alias || [],
    redirect: indexldVuzk9a7dMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexldVuzk9a7dMeta?.name ?? "etf-transaction-history___nl",
    path: indexldVuzk9a7dMeta?.path ?? "/nl/etf-transaction-history",
    meta: indexldVuzk9a7dMeta || {},
    alias: indexldVuzk9a7dMeta?.alias || [],
    redirect: indexldVuzk9a7dMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/etf-transaction-history/index.vue").then(m => m.default || m)
  },
  {
    name: index6rlZmVXVfZMeta?.name ?? "inbox-message___de",
    path: index6rlZmVXVfZMeta?.path ?? "/de/inbox-message",
    meta: index6rlZmVXVfZMeta || {},
    alias: index6rlZmVXVfZMeta?.alias || [],
    redirect: index6rlZmVXVfZMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: index6rlZmVXVfZMeta?.name ?? "inbox-message___en",
    path: index6rlZmVXVfZMeta?.path ?? "/en/inbox-message",
    meta: index6rlZmVXVfZMeta || {},
    alias: index6rlZmVXVfZMeta?.alias || [],
    redirect: index6rlZmVXVfZMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: index6rlZmVXVfZMeta?.name ?? "inbox-message___fr",
    path: index6rlZmVXVfZMeta?.path ?? "/fr/inbox-message",
    meta: index6rlZmVXVfZMeta || {},
    alias: index6rlZmVXVfZMeta?.alias || [],
    redirect: index6rlZmVXVfZMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: index6rlZmVXVfZMeta?.name ?? "inbox-message___nl",
    path: index6rlZmVXVfZMeta?.path ?? "/nl/inbox-message",
    meta: index6rlZmVXVfZMeta || {},
    alias: index6rlZmVXVfZMeta?.alias || [],
    redirect: index6rlZmVXVfZMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/inbox-message/index.vue").then(m => m.default || m)
  },
  {
    name: index3pXrB6Z18SMeta?.name ?? "index___de",
    path: index3pXrB6Z18SMeta?.path ?? "/de",
    meta: index3pXrB6Z18SMeta || {},
    alias: index3pXrB6Z18SMeta?.alias || [],
    redirect: index3pXrB6Z18SMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index3pXrB6Z18SMeta?.name ?? "index___en",
    path: index3pXrB6Z18SMeta?.path ?? "/en",
    meta: index3pXrB6Z18SMeta || {},
    alias: index3pXrB6Z18SMeta?.alias || [],
    redirect: index3pXrB6Z18SMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index3pXrB6Z18SMeta?.name ?? "index___fr",
    path: index3pXrB6Z18SMeta?.path ?? "/fr",
    meta: index3pXrB6Z18SMeta || {},
    alias: index3pXrB6Z18SMeta?.alias || [],
    redirect: index3pXrB6Z18SMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/index.vue").then(m => m.default || m)
  },
  {
    name: index3pXrB6Z18SMeta?.name ?? "index___nl",
    path: index3pXrB6Z18SMeta?.path ?? "/nl",
    meta: index3pXrB6Z18SMeta || {},
    alias: index3pXrB6Z18SMeta?.alias || [],
    redirect: index3pXrB6Z18SMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/index.vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93bzpnwUsQ4YMeta?.name ?? "instruments-buy-isin___de",
    path: _91_91isin_93_93bzpnwUsQ4YMeta?.path ?? "/de/instruments/buy/:isin?",
    meta: _91_91isin_93_93bzpnwUsQ4YMeta || {},
    alias: _91_91isin_93_93bzpnwUsQ4YMeta?.alias || [],
    redirect: _91_91isin_93_93bzpnwUsQ4YMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93bzpnwUsQ4YMeta?.name ?? "instruments-buy-isin___en",
    path: _91_91isin_93_93bzpnwUsQ4YMeta?.path ?? "/en/instruments/buy/:isin?",
    meta: _91_91isin_93_93bzpnwUsQ4YMeta || {},
    alias: _91_91isin_93_93bzpnwUsQ4YMeta?.alias || [],
    redirect: _91_91isin_93_93bzpnwUsQ4YMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93bzpnwUsQ4YMeta?.name ?? "instruments-buy-isin___fr",
    path: _91_91isin_93_93bzpnwUsQ4YMeta?.path ?? "/fr/instruments/buy/:isin?",
    meta: _91_91isin_93_93bzpnwUsQ4YMeta || {},
    alias: _91_91isin_93_93bzpnwUsQ4YMeta?.alias || [],
    redirect: _91_91isin_93_93bzpnwUsQ4YMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93bzpnwUsQ4YMeta?.name ?? "instruments-buy-isin___nl",
    path: _91_91isin_93_93bzpnwUsQ4YMeta?.path ?? "/nl/instruments/buy/:isin?",
    meta: _91_91isin_93_93bzpnwUsQ4YMeta || {},
    alias: _91_91isin_93_93bzpnwUsQ4YMeta?.alias || [],
    redirect: _91_91isin_93_93bzpnwUsQ4YMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/buy/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93vN6WXwU7zeMeta?.name ?? "instruments-details-isin___de",
    path: _91isin_93vN6WXwU7zeMeta?.path ?? "/de/instruments/details/:isin()",
    meta: _91isin_93vN6WXwU7zeMeta || {},
    alias: _91isin_93vN6WXwU7zeMeta?.alias || [],
    redirect: _91isin_93vN6WXwU7zeMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93vN6WXwU7zeMeta?.name ?? "instruments-details-isin___en",
    path: _91isin_93vN6WXwU7zeMeta?.path ?? "/en/instruments/details/:isin()",
    meta: _91isin_93vN6WXwU7zeMeta || {},
    alias: _91isin_93vN6WXwU7zeMeta?.alias || [],
    redirect: _91isin_93vN6WXwU7zeMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93vN6WXwU7zeMeta?.name ?? "instruments-details-isin___fr",
    path: _91isin_93vN6WXwU7zeMeta?.path ?? "/fr/instruments/details/:isin()",
    meta: _91isin_93vN6WXwU7zeMeta || {},
    alias: _91isin_93vN6WXwU7zeMeta?.alias || [],
    redirect: _91isin_93vN6WXwU7zeMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: _91isin_93vN6WXwU7zeMeta?.name ?? "instruments-details-isin___nl",
    path: _91isin_93vN6WXwU7zeMeta?.path ?? "/nl/instruments/details/:isin()",
    meta: _91isin_93vN6WXwU7zeMeta || {},
    alias: _91isin_93vN6WXwU7zeMeta?.alias || [],
    redirect: _91isin_93vN6WXwU7zeMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/details/[isin].vue").then(m => m.default || m)
  },
  {
    name: index_old0A1MClJpAtMeta?.name ?? "instruments-index_old___de",
    path: index_old0A1MClJpAtMeta?.path ?? "/de/instruments/index_old",
    meta: index_old0A1MClJpAtMeta || {},
    alias: index_old0A1MClJpAtMeta?.alias || [],
    redirect: index_old0A1MClJpAtMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/index_old.vue").then(m => m.default || m)
  },
  {
    name: index_old0A1MClJpAtMeta?.name ?? "instruments-index_old___en",
    path: index_old0A1MClJpAtMeta?.path ?? "/en/instruments/index_old",
    meta: index_old0A1MClJpAtMeta || {},
    alias: index_old0A1MClJpAtMeta?.alias || [],
    redirect: index_old0A1MClJpAtMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/index_old.vue").then(m => m.default || m)
  },
  {
    name: index_old0A1MClJpAtMeta?.name ?? "instruments-index_old___fr",
    path: index_old0A1MClJpAtMeta?.path ?? "/fr/instruments/index_old",
    meta: index_old0A1MClJpAtMeta || {},
    alias: index_old0A1MClJpAtMeta?.alias || [],
    redirect: index_old0A1MClJpAtMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/index_old.vue").then(m => m.default || m)
  },
  {
    name: index_old0A1MClJpAtMeta?.name ?? "instruments-index_old___nl",
    path: index_old0A1MClJpAtMeta?.path ?? "/nl/instruments/index_old",
    meta: index_old0A1MClJpAtMeta || {},
    alias: index_old0A1MClJpAtMeta?.alias || [],
    redirect: index_old0A1MClJpAtMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/index_old.vue").then(m => m.default || m)
  },
  {
    name: indexbAa1NUTpAmMeta?.name ?? "instruments___de",
    path: indexbAa1NUTpAmMeta?.path ?? "/de/instruments",
    meta: indexbAa1NUTpAmMeta || {},
    alias: indexbAa1NUTpAmMeta?.alias || [],
    redirect: indexbAa1NUTpAmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indexbAa1NUTpAmMeta?.name ?? "instruments___en",
    path: indexbAa1NUTpAmMeta?.path ?? "/en/instruments",
    meta: indexbAa1NUTpAmMeta || {},
    alias: indexbAa1NUTpAmMeta?.alias || [],
    redirect: indexbAa1NUTpAmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indexbAa1NUTpAmMeta?.name ?? "instruments___fr",
    path: indexbAa1NUTpAmMeta?.path ?? "/fr/instruments",
    meta: indexbAa1NUTpAmMeta || {},
    alias: indexbAa1NUTpAmMeta?.alias || [],
    redirect: indexbAa1NUTpAmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indexbAa1NUTpAmMeta?.name ?? "instruments___nl",
    path: indexbAa1NUTpAmMeta?.path ?? "/nl/instruments",
    meta: indexbAa1NUTpAmMeta || {},
    alias: indexbAa1NUTpAmMeta?.alias || [],
    redirect: indexbAa1NUTpAmMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/index.vue").then(m => m.default || m)
  },
  {
    name: indexDYEZ1agkfOMeta?.name ?? "instruments-list___de",
    path: indexDYEZ1agkfOMeta?.path ?? "/de/instruments/list",
    meta: indexDYEZ1agkfOMeta || {},
    alias: indexDYEZ1agkfOMeta?.alias || [],
    redirect: indexDYEZ1agkfOMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: indexDYEZ1agkfOMeta?.name ?? "instruments-list___en",
    path: indexDYEZ1agkfOMeta?.path ?? "/en/instruments/list",
    meta: indexDYEZ1agkfOMeta || {},
    alias: indexDYEZ1agkfOMeta?.alias || [],
    redirect: indexDYEZ1agkfOMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: indexDYEZ1agkfOMeta?.name ?? "instruments-list___fr",
    path: indexDYEZ1agkfOMeta?.path ?? "/fr/instruments/list",
    meta: indexDYEZ1agkfOMeta || {},
    alias: indexDYEZ1agkfOMeta?.alias || [],
    redirect: indexDYEZ1agkfOMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: indexDYEZ1agkfOMeta?.name ?? "instruments-list___nl",
    path: indexDYEZ1agkfOMeta?.path ?? "/nl/instruments/list",
    meta: indexDYEZ1agkfOMeta || {},
    alias: indexDYEZ1agkfOMeta?.alias || [],
    redirect: indexDYEZ1agkfOMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/list/index.vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_936BwvTLbxcXMeta?.name ?? "instruments-savings-plan-add-isin___de",
    path: _91_91isin_93_936BwvTLbxcXMeta?.path ?? "/de/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_936BwvTLbxcXMeta || {},
    alias: _91_91isin_93_936BwvTLbxcXMeta?.alias || [],
    redirect: _91_91isin_93_936BwvTLbxcXMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_936BwvTLbxcXMeta?.name ?? "instruments-savings-plan-add-isin___en",
    path: _91_91isin_93_936BwvTLbxcXMeta?.path ?? "/en/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_936BwvTLbxcXMeta || {},
    alias: _91_91isin_93_936BwvTLbxcXMeta?.alias || [],
    redirect: _91_91isin_93_936BwvTLbxcXMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_936BwvTLbxcXMeta?.name ?? "instruments-savings-plan-add-isin___fr",
    path: _91_91isin_93_936BwvTLbxcXMeta?.path ?? "/fr/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_936BwvTLbxcXMeta || {},
    alias: _91_91isin_93_936BwvTLbxcXMeta?.alias || [],
    redirect: _91_91isin_93_936BwvTLbxcXMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_936BwvTLbxcXMeta?.name ?? "instruments-savings-plan-add-isin___nl",
    path: _91_91isin_93_936BwvTLbxcXMeta?.path ?? "/nl/instruments/savings-plan/add/:isin?",
    meta: _91_91isin_93_936BwvTLbxcXMeta || {},
    alias: _91_91isin_93_936BwvTLbxcXMeta?.alias || [],
    redirect: _91_91isin_93_936BwvTLbxcXMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/savings-plan/add/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93wwQnJ5fNkfMeta?.name ?? "instruments-sell-isin___de",
    path: _91_91isin_93_93wwQnJ5fNkfMeta?.path ?? "/de/instruments/sell/:isin?",
    meta: _91_91isin_93_93wwQnJ5fNkfMeta || {},
    alias: _91_91isin_93_93wwQnJ5fNkfMeta?.alias || [],
    redirect: _91_91isin_93_93wwQnJ5fNkfMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93wwQnJ5fNkfMeta?.name ?? "instruments-sell-isin___en",
    path: _91_91isin_93_93wwQnJ5fNkfMeta?.path ?? "/en/instruments/sell/:isin?",
    meta: _91_91isin_93_93wwQnJ5fNkfMeta || {},
    alias: _91_91isin_93_93wwQnJ5fNkfMeta?.alias || [],
    redirect: _91_91isin_93_93wwQnJ5fNkfMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93wwQnJ5fNkfMeta?.name ?? "instruments-sell-isin___fr",
    path: _91_91isin_93_93wwQnJ5fNkfMeta?.path ?? "/fr/instruments/sell/:isin?",
    meta: _91_91isin_93_93wwQnJ5fNkfMeta || {},
    alias: _91_91isin_93_93wwQnJ5fNkfMeta?.alias || [],
    redirect: _91_91isin_93_93wwQnJ5fNkfMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: _91_91isin_93_93wwQnJ5fNkfMeta?.name ?? "instruments-sell-isin___nl",
    path: _91_91isin_93_93wwQnJ5fNkfMeta?.path ?? "/nl/instruments/sell/:isin?",
    meta: _91_91isin_93_93wwQnJ5fNkfMeta || {},
    alias: _91_91isin_93_93wwQnJ5fNkfMeta?.alias || [],
    redirect: _91_91isin_93_93wwQnJ5fNkfMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/sell/[[isin]].vue").then(m => m.default || m)
  },
  {
    name: indexH1BPmoh3L1Meta?.name ?? "instruments-tax-exemption___de",
    path: indexH1BPmoh3L1Meta?.path ?? "/de/instruments/tax-exemption",
    meta: indexH1BPmoh3L1Meta || {},
    alias: indexH1BPmoh3L1Meta?.alias || [],
    redirect: indexH1BPmoh3L1Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: indexH1BPmoh3L1Meta?.name ?? "instruments-tax-exemption___en",
    path: indexH1BPmoh3L1Meta?.path ?? "/en/instruments/tax-exemption",
    meta: indexH1BPmoh3L1Meta || {},
    alias: indexH1BPmoh3L1Meta?.alias || [],
    redirect: indexH1BPmoh3L1Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: indexH1BPmoh3L1Meta?.name ?? "instruments-tax-exemption___fr",
    path: indexH1BPmoh3L1Meta?.path ?? "/fr/instruments/tax-exemption",
    meta: indexH1BPmoh3L1Meta || {},
    alias: indexH1BPmoh3L1Meta?.alias || [],
    redirect: indexH1BPmoh3L1Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: indexH1BPmoh3L1Meta?.name ?? "instruments-tax-exemption___nl",
    path: indexH1BPmoh3L1Meta?.path ?? "/nl/instruments/tax-exemption",
    meta: indexH1BPmoh3L1Meta || {},
    alias: indexH1BPmoh3L1Meta?.alias || [],
    redirect: indexH1BPmoh3L1Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/instruments/tax-exemption/index.vue").then(m => m.default || m)
  },
  {
    name: loginoojCoP1BXdMeta?.name ?? "login___de",
    path: loginoojCoP1BXdMeta?.path ?? "/de/login",
    meta: loginoojCoP1BXdMeta || {},
    alias: loginoojCoP1BXdMeta?.alias || [],
    redirect: loginoojCoP1BXdMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginoojCoP1BXdMeta?.name ?? "login___en",
    path: loginoojCoP1BXdMeta?.path ?? "/en/login",
    meta: loginoojCoP1BXdMeta || {},
    alias: loginoojCoP1BXdMeta?.alias || [],
    redirect: loginoojCoP1BXdMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginoojCoP1BXdMeta?.name ?? "login___fr",
    path: loginoojCoP1BXdMeta?.path ?? "/fr/login",
    meta: loginoojCoP1BXdMeta || {},
    alias: loginoojCoP1BXdMeta?.alias || [],
    redirect: loginoojCoP1BXdMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginoojCoP1BXdMeta?.name ?? "login___nl",
    path: loginoojCoP1BXdMeta?.path ?? "/nl/login",
    meta: loginoojCoP1BXdMeta || {},
    alias: loginoojCoP1BXdMeta?.alias || [],
    redirect: loginoojCoP1BXdMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/login.vue").then(m => m.default || m)
  },
  {
    name: indexMySkabLD7yMeta?.name ?? "profile___de",
    path: indexMySkabLD7yMeta?.path ?? "/de/profile",
    meta: indexMySkabLD7yMeta || {},
    alias: indexMySkabLD7yMeta?.alias || [],
    redirect: indexMySkabLD7yMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexMySkabLD7yMeta?.name ?? "profile___en",
    path: indexMySkabLD7yMeta?.path ?? "/en/profile",
    meta: indexMySkabLD7yMeta || {},
    alias: indexMySkabLD7yMeta?.alias || [],
    redirect: indexMySkabLD7yMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexMySkabLD7yMeta?.name ?? "profile___fr",
    path: indexMySkabLD7yMeta?.path ?? "/fr/profile",
    meta: indexMySkabLD7yMeta || {},
    alias: indexMySkabLD7yMeta?.alias || [],
    redirect: indexMySkabLD7yMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexMySkabLD7yMeta?.name ?? "profile___nl",
    path: indexMySkabLD7yMeta?.path ?? "/nl/profile",
    meta: indexMySkabLD7yMeta || {},
    alias: indexMySkabLD7yMeta?.alias || [],
    redirect: indexMySkabLD7yMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: verifyk9WC9puIGkMeta?.name ?? "profile-verify___de",
    path: verifyk9WC9puIGkMeta?.path ?? "/de/profile/verify",
    meta: verifyk9WC9puIGkMeta || {},
    alias: verifyk9WC9puIGkMeta?.alias || [],
    redirect: verifyk9WC9puIGkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: verifyk9WC9puIGkMeta?.name ?? "profile-verify___en",
    path: verifyk9WC9puIGkMeta?.path ?? "/en/profile/verify",
    meta: verifyk9WC9puIGkMeta || {},
    alias: verifyk9WC9puIGkMeta?.alias || [],
    redirect: verifyk9WC9puIGkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: verifyk9WC9puIGkMeta?.name ?? "profile-verify___fr",
    path: verifyk9WC9puIGkMeta?.path ?? "/fr/profile/verify",
    meta: verifyk9WC9puIGkMeta || {},
    alias: verifyk9WC9puIGkMeta?.alias || [],
    redirect: verifyk9WC9puIGkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: verifyk9WC9puIGkMeta?.name ?? "profile-verify___nl",
    path: verifyk9WC9puIGkMeta?.path ?? "/nl/profile/verify",
    meta: verifyk9WC9puIGkMeta || {},
    alias: verifyk9WC9puIGkMeta?.alias || [],
    redirect: verifyk9WC9puIGkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/profile/verify.vue").then(m => m.default || m)
  },
  {
    name: registerb4XSeQjzDZMeta?.name ?? "register___de",
    path: registerb4XSeQjzDZMeta?.path ?? "/de/register",
    meta: registerb4XSeQjzDZMeta || {},
    alias: registerb4XSeQjzDZMeta?.alias || [],
    redirect: registerb4XSeQjzDZMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerb4XSeQjzDZMeta?.name ?? "register___en",
    path: registerb4XSeQjzDZMeta?.path ?? "/en/register",
    meta: registerb4XSeQjzDZMeta || {},
    alias: registerb4XSeQjzDZMeta?.alias || [],
    redirect: registerb4XSeQjzDZMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerb4XSeQjzDZMeta?.name ?? "register___fr",
    path: registerb4XSeQjzDZMeta?.path ?? "/fr/register",
    meta: registerb4XSeQjzDZMeta || {},
    alias: registerb4XSeQjzDZMeta?.alias || [],
    redirect: registerb4XSeQjzDZMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/register.vue").then(m => m.default || m)
  },
  {
    name: registerb4XSeQjzDZMeta?.name ?? "register___nl",
    path: registerb4XSeQjzDZMeta?.path ?? "/nl/register",
    meta: registerb4XSeQjzDZMeta || {},
    alias: registerb4XSeQjzDZMeta?.alias || [],
    redirect: registerb4XSeQjzDZMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/register.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordlENL1CYpeqMeta?.name ?? "request-password___de",
    path: request_45passwordlENL1CYpeqMeta?.path ?? "/de/request-password",
    meta: request_45passwordlENL1CYpeqMeta || {},
    alias: request_45passwordlENL1CYpeqMeta?.alias || [],
    redirect: request_45passwordlENL1CYpeqMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordlENL1CYpeqMeta?.name ?? "request-password___en",
    path: request_45passwordlENL1CYpeqMeta?.path ?? "/en/request-password",
    meta: request_45passwordlENL1CYpeqMeta || {},
    alias: request_45passwordlENL1CYpeqMeta?.alias || [],
    redirect: request_45passwordlENL1CYpeqMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordlENL1CYpeqMeta?.name ?? "request-password___fr",
    path: request_45passwordlENL1CYpeqMeta?.path ?? "/fr/request-password",
    meta: request_45passwordlENL1CYpeqMeta || {},
    alias: request_45passwordlENL1CYpeqMeta?.alias || [],
    redirect: request_45passwordlENL1CYpeqMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: request_45passwordlENL1CYpeqMeta?.name ?? "request-password___nl",
    path: request_45passwordlENL1CYpeqMeta?.path ?? "/nl/request-password",
    meta: request_45passwordlENL1CYpeqMeta || {},
    alias: request_45passwordlENL1CYpeqMeta?.alias || [],
    redirect: request_45passwordlENL1CYpeqMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/request-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordEUzwTxxs6KMeta?.name ?? "reset-password___de",
    path: reset_45passwordEUzwTxxs6KMeta?.path ?? "/de/reset-password",
    meta: reset_45passwordEUzwTxxs6KMeta || {},
    alias: reset_45passwordEUzwTxxs6KMeta?.alias || [],
    redirect: reset_45passwordEUzwTxxs6KMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordEUzwTxxs6KMeta?.name ?? "reset-password___en",
    path: reset_45passwordEUzwTxxs6KMeta?.path ?? "/en/reset-password",
    meta: reset_45passwordEUzwTxxs6KMeta || {},
    alias: reset_45passwordEUzwTxxs6KMeta?.alias || [],
    redirect: reset_45passwordEUzwTxxs6KMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordEUzwTxxs6KMeta?.name ?? "reset-password___fr",
    path: reset_45passwordEUzwTxxs6KMeta?.path ?? "/fr/reset-password",
    meta: reset_45passwordEUzwTxxs6KMeta || {},
    alias: reset_45passwordEUzwTxxs6KMeta?.alias || [],
    redirect: reset_45passwordEUzwTxxs6KMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45passwordEUzwTxxs6KMeta?.name ?? "reset-password___nl",
    path: reset_45passwordEUzwTxxs6KMeta?.path ?? "/nl/reset-password",
    meta: reset_45passwordEUzwTxxs6KMeta || {},
    alias: reset_45passwordEUzwTxxs6KMeta?.alias || [],
    redirect: reset_45passwordEUzwTxxs6KMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/reset-password.vue").then(m => m.default || m)
  },
  {
    name: reset_45pinMQcfdqgqlEMeta?.name ?? "reset-pin___de",
    path: reset_45pinMQcfdqgqlEMeta?.path ?? "/de/reset-pin",
    meta: reset_45pinMQcfdqgqlEMeta || {},
    alias: reset_45pinMQcfdqgqlEMeta?.alias || [],
    redirect: reset_45pinMQcfdqgqlEMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: reset_45pinMQcfdqgqlEMeta?.name ?? "reset-pin___en",
    path: reset_45pinMQcfdqgqlEMeta?.path ?? "/en/reset-pin",
    meta: reset_45pinMQcfdqgqlEMeta || {},
    alias: reset_45pinMQcfdqgqlEMeta?.alias || [],
    redirect: reset_45pinMQcfdqgqlEMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: reset_45pinMQcfdqgqlEMeta?.name ?? "reset-pin___fr",
    path: reset_45pinMQcfdqgqlEMeta?.path ?? "/fr/reset-pin",
    meta: reset_45pinMQcfdqgqlEMeta || {},
    alias: reset_45pinMQcfdqgqlEMeta?.alias || [],
    redirect: reset_45pinMQcfdqgqlEMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: reset_45pinMQcfdqgqlEMeta?.name ?? "reset-pin___nl",
    path: reset_45pinMQcfdqgqlEMeta?.path ?? "/nl/reset-pin",
    meta: reset_45pinMQcfdqgqlEMeta || {},
    alias: reset_45pinMQcfdqgqlEMeta?.alias || [],
    redirect: reset_45pinMQcfdqgqlEMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/reset-pin.vue").then(m => m.default || m)
  },
  {
    name: indexOJYtmcPvW4Meta?.name ?? "security-legal-document___de",
    path: indexOJYtmcPvW4Meta?.path ?? "/de/security-legal-document",
    meta: indexOJYtmcPvW4Meta || {},
    alias: indexOJYtmcPvW4Meta?.alias || [],
    redirect: indexOJYtmcPvW4Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: indexOJYtmcPvW4Meta?.name ?? "security-legal-document___en",
    path: indexOJYtmcPvW4Meta?.path ?? "/en/security-legal-document",
    meta: indexOJYtmcPvW4Meta || {},
    alias: indexOJYtmcPvW4Meta?.alias || [],
    redirect: indexOJYtmcPvW4Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: indexOJYtmcPvW4Meta?.name ?? "security-legal-document___fr",
    path: indexOJYtmcPvW4Meta?.path ?? "/fr/security-legal-document",
    meta: indexOJYtmcPvW4Meta || {},
    alias: indexOJYtmcPvW4Meta?.alias || [],
    redirect: indexOJYtmcPvW4Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: indexOJYtmcPvW4Meta?.name ?? "security-legal-document___nl",
    path: indexOJYtmcPvW4Meta?.path ?? "/nl/security-legal-document",
    meta: indexOJYtmcPvW4Meta || {},
    alias: indexOJYtmcPvW4Meta?.alias || [],
    redirect: indexOJYtmcPvW4Meta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/security-legal-document/index.vue").then(m => m.default || m)
  },
  {
    name: simulatorSNZaD0XieHMeta?.name ?? "simulator___de",
    path: simulatorSNZaD0XieHMeta?.path ?? "/de/simulator",
    meta: simulatorSNZaD0XieHMeta || {},
    alias: simulatorSNZaD0XieHMeta?.alias || [],
    redirect: simulatorSNZaD0XieHMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: simulatorSNZaD0XieHMeta?.name ?? "simulator___en",
    path: simulatorSNZaD0XieHMeta?.path ?? "/en/simulator",
    meta: simulatorSNZaD0XieHMeta || {},
    alias: simulatorSNZaD0XieHMeta?.alias || [],
    redirect: simulatorSNZaD0XieHMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: simulatorSNZaD0XieHMeta?.name ?? "simulator___fr",
    path: simulatorSNZaD0XieHMeta?.path ?? "/fr/simulator",
    meta: simulatorSNZaD0XieHMeta || {},
    alias: simulatorSNZaD0XieHMeta?.alias || [],
    redirect: simulatorSNZaD0XieHMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: simulatorSNZaD0XieHMeta?.name ?? "simulator___nl",
    path: simulatorSNZaD0XieHMeta?.path ?? "/nl/simulator",
    meta: simulatorSNZaD0XieHMeta || {},
    alias: simulatorSNZaD0XieHMeta?.alias || [],
    redirect: simulatorSNZaD0XieHMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/simulator.vue").then(m => m.default || m)
  },
  {
    name: indexoi7YKemXLiMeta?.name ?? "support-tickets___de",
    path: indexoi7YKemXLiMeta?.path ?? "/de/support-tickets",
    meta: indexoi7YKemXLiMeta || {},
    alias: indexoi7YKemXLiMeta?.alias || [],
    redirect: indexoi7YKemXLiMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: indexoi7YKemXLiMeta?.name ?? "support-tickets___en",
    path: indexoi7YKemXLiMeta?.path ?? "/en/support-tickets",
    meta: indexoi7YKemXLiMeta || {},
    alias: indexoi7YKemXLiMeta?.alias || [],
    redirect: indexoi7YKemXLiMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: indexoi7YKemXLiMeta?.name ?? "support-tickets___fr",
    path: indexoi7YKemXLiMeta?.path ?? "/fr/support-tickets",
    meta: indexoi7YKemXLiMeta || {},
    alias: indexoi7YKemXLiMeta?.alias || [],
    redirect: indexoi7YKemXLiMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: indexoi7YKemXLiMeta?.name ?? "support-tickets___nl",
    path: indexoi7YKemXLiMeta?.path ?? "/nl/support-tickets",
    meta: indexoi7YKemXLiMeta || {},
    alias: indexoi7YKemXLiMeta?.alias || [],
    redirect: indexoi7YKemXLiMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/support-tickets/index.vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93FVu8kimYmWMeta?.name ?? "trading-buy-depotid___de",
    path: _91_91depotid_93_93FVu8kimYmWMeta?.path ?? "/de/trading/buy/:depotid?",
    meta: _91_91depotid_93_93FVu8kimYmWMeta || {},
    alias: _91_91depotid_93_93FVu8kimYmWMeta?.alias || [],
    redirect: _91_91depotid_93_93FVu8kimYmWMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93FVu8kimYmWMeta?.name ?? "trading-buy-depotid___en",
    path: _91_91depotid_93_93FVu8kimYmWMeta?.path ?? "/en/trading/buy/:depotid?",
    meta: _91_91depotid_93_93FVu8kimYmWMeta || {},
    alias: _91_91depotid_93_93FVu8kimYmWMeta?.alias || [],
    redirect: _91_91depotid_93_93FVu8kimYmWMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93FVu8kimYmWMeta?.name ?? "trading-buy-depotid___fr",
    path: _91_91depotid_93_93FVu8kimYmWMeta?.path ?? "/fr/trading/buy/:depotid?",
    meta: _91_91depotid_93_93FVu8kimYmWMeta || {},
    alias: _91_91depotid_93_93FVu8kimYmWMeta?.alias || [],
    redirect: _91_91depotid_93_93FVu8kimYmWMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93FVu8kimYmWMeta?.name ?? "trading-buy-depotid___nl",
    path: _91_91depotid_93_93FVu8kimYmWMeta?.path ?? "/nl/trading/buy/:depotid?",
    meta: _91_91depotid_93_93FVu8kimYmWMeta || {},
    alias: _91_91depotid_93_93FVu8kimYmWMeta?.alias || [],
    redirect: _91_91depotid_93_93FVu8kimYmWMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/buy/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_939ECQOIddwkMeta?.name ?? "trading-delivery-depotid___de",
    path: _91_91depotid_93_939ECQOIddwkMeta?.path ?? "/de/trading/delivery/:depotid?",
    meta: _91_91depotid_93_939ECQOIddwkMeta || {},
    alias: _91_91depotid_93_939ECQOIddwkMeta?.alias || [],
    redirect: _91_91depotid_93_939ECQOIddwkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_939ECQOIddwkMeta?.name ?? "trading-delivery-depotid___en",
    path: _91_91depotid_93_939ECQOIddwkMeta?.path ?? "/en/trading/delivery/:depotid?",
    meta: _91_91depotid_93_939ECQOIddwkMeta || {},
    alias: _91_91depotid_93_939ECQOIddwkMeta?.alias || [],
    redirect: _91_91depotid_93_939ECQOIddwkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_939ECQOIddwkMeta?.name ?? "trading-delivery-depotid___fr",
    path: _91_91depotid_93_939ECQOIddwkMeta?.path ?? "/fr/trading/delivery/:depotid?",
    meta: _91_91depotid_93_939ECQOIddwkMeta || {},
    alias: _91_91depotid_93_939ECQOIddwkMeta?.alias || [],
    redirect: _91_91depotid_93_939ECQOIddwkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_939ECQOIddwkMeta?.name ?? "trading-delivery-depotid___nl",
    path: _91_91depotid_93_939ECQOIddwkMeta?.path ?? "/nl/trading/delivery/:depotid?",
    meta: _91_91depotid_93_939ECQOIddwkMeta || {},
    alias: _91_91depotid_93_939ECQOIddwkMeta?.alias || [],
    redirect: _91_91depotid_93_939ECQOIddwkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/delivery/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93QtA5akYQBXMeta?.name ?? "trading-sell-depotid___de",
    path: _91_91depotid_93_93QtA5akYQBXMeta?.path ?? "/de/trading/sell/:depotid?",
    meta: _91_91depotid_93_93QtA5akYQBXMeta || {},
    alias: _91_91depotid_93_93QtA5akYQBXMeta?.alias || [],
    redirect: _91_91depotid_93_93QtA5akYQBXMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93QtA5akYQBXMeta?.name ?? "trading-sell-depotid___en",
    path: _91_91depotid_93_93QtA5akYQBXMeta?.path ?? "/en/trading/sell/:depotid?",
    meta: _91_91depotid_93_93QtA5akYQBXMeta || {},
    alias: _91_91depotid_93_93QtA5akYQBXMeta?.alias || [],
    redirect: _91_91depotid_93_93QtA5akYQBXMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93QtA5akYQBXMeta?.name ?? "trading-sell-depotid___fr",
    path: _91_91depotid_93_93QtA5akYQBXMeta?.path ?? "/fr/trading/sell/:depotid?",
    meta: _91_91depotid_93_93QtA5akYQBXMeta || {},
    alias: _91_91depotid_93_93QtA5akYQBXMeta?.alias || [],
    redirect: _91_91depotid_93_93QtA5akYQBXMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_93QtA5akYQBXMeta?.name ?? "trading-sell-depotid___nl",
    path: _91_91depotid_93_93QtA5akYQBXMeta?.path ?? "/nl/trading/sell/:depotid?",
    meta: _91_91depotid_93_93QtA5akYQBXMeta || {},
    alias: _91_91depotid_93_93QtA5akYQBXMeta?.alias || [],
    redirect: _91_91depotid_93_93QtA5akYQBXMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/sell/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_937EWRborpobMeta?.name ?? "trading-transfer-depotid___de",
    path: _91_91depotid_93_937EWRborpobMeta?.path ?? "/de/trading/transfer/:depotid?",
    meta: _91_91depotid_93_937EWRborpobMeta || {},
    alias: _91_91depotid_93_937EWRborpobMeta?.alias || [],
    redirect: _91_91depotid_93_937EWRborpobMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_937EWRborpobMeta?.name ?? "trading-transfer-depotid___en",
    path: _91_91depotid_93_937EWRborpobMeta?.path ?? "/en/trading/transfer/:depotid?",
    meta: _91_91depotid_93_937EWRborpobMeta || {},
    alias: _91_91depotid_93_937EWRborpobMeta?.alias || [],
    redirect: _91_91depotid_93_937EWRborpobMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_937EWRborpobMeta?.name ?? "trading-transfer-depotid___fr",
    path: _91_91depotid_93_937EWRborpobMeta?.path ?? "/fr/trading/transfer/:depotid?",
    meta: _91_91depotid_93_937EWRborpobMeta || {},
    alias: _91_91depotid_93_937EWRborpobMeta?.alias || [],
    redirect: _91_91depotid_93_937EWRborpobMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: _91_91depotid_93_937EWRborpobMeta?.name ?? "trading-transfer-depotid___nl",
    path: _91_91depotid_93_937EWRborpobMeta?.path ?? "/nl/trading/transfer/:depotid?",
    meta: _91_91depotid_93_937EWRborpobMeta || {},
    alias: _91_91depotid_93_937EWRborpobMeta?.alias || [],
    redirect: _91_91depotid_93_937EWRborpobMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/trading/transfer/[[depotid]].vue").then(m => m.default || m)
  },
  {
    name: indexX3C3MZr5BkMeta?.name ?? "upvest-account-history___de",
    path: indexX3C3MZr5BkMeta?.path ?? "/de/upvest-account-history",
    meta: indexX3C3MZr5BkMeta || {},
    alias: indexX3C3MZr5BkMeta?.alias || [],
    redirect: indexX3C3MZr5BkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexX3C3MZr5BkMeta?.name ?? "upvest-account-history___en",
    path: indexX3C3MZr5BkMeta?.path ?? "/en/upvest-account-history",
    meta: indexX3C3MZr5BkMeta || {},
    alias: indexX3C3MZr5BkMeta?.alias || [],
    redirect: indexX3C3MZr5BkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexX3C3MZr5BkMeta?.name ?? "upvest-account-history___fr",
    path: indexX3C3MZr5BkMeta?.path ?? "/fr/upvest-account-history",
    meta: indexX3C3MZr5BkMeta || {},
    alias: indexX3C3MZr5BkMeta?.alias || [],
    redirect: indexX3C3MZr5BkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexX3C3MZr5BkMeta?.name ?? "upvest-account-history___nl",
    path: indexX3C3MZr5BkMeta?.path ?? "/nl/upvest-account-history",
    meta: indexX3C3MZr5BkMeta || {},
    alias: indexX3C3MZr5BkMeta?.alias || [],
    redirect: indexX3C3MZr5BkMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/upvest-account-history/index.vue").then(m => m.default || m)
  },
  {
    name: indexvRlJgmSR2fMeta?.name ?? "upvest-activate___de",
    path: indexvRlJgmSR2fMeta?.path ?? "/de/upvest-activate",
    meta: indexvRlJgmSR2fMeta || {},
    alias: indexvRlJgmSR2fMeta?.alias || [],
    redirect: indexvRlJgmSR2fMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/upvest-activate/index.vue").then(m => m.default || m)
  },
  {
    name: indexvRlJgmSR2fMeta?.name ?? "upvest-activate___en",
    path: indexvRlJgmSR2fMeta?.path ?? "/en/upvest-activate",
    meta: indexvRlJgmSR2fMeta || {},
    alias: indexvRlJgmSR2fMeta?.alias || [],
    redirect: indexvRlJgmSR2fMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/upvest-activate/index.vue").then(m => m.default || m)
  },
  {
    name: indexvRlJgmSR2fMeta?.name ?? "upvest-activate___fr",
    path: indexvRlJgmSR2fMeta?.path ?? "/fr/upvest-activate",
    meta: indexvRlJgmSR2fMeta || {},
    alias: indexvRlJgmSR2fMeta?.alias || [],
    redirect: indexvRlJgmSR2fMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/upvest-activate/index.vue").then(m => m.default || m)
  },
  {
    name: indexvRlJgmSR2fMeta?.name ?? "upvest-activate___nl",
    path: indexvRlJgmSR2fMeta?.path ?? "/nl/upvest-activate",
    meta: indexvRlJgmSR2fMeta || {},
    alias: indexvRlJgmSR2fMeta?.alias || [],
    redirect: indexvRlJgmSR2fMeta?.redirect,
    component: () => import("/home/forge/app.inaia.uk/pages/upvest-activate/index.vue").then(m => m.default || m)
  }
]